const getters = {
  // sidebar: state => state.app.sidebar,
  // device: state => state.app.device,
  token: state => state.session.token,
  // avatar: state => state.current_user.avatar,
  name: state => state.session.user_name,
  isLogin: state => state.session.user_id,
  ssSearch: state => {
    const s = state.sales_slip
    return {
      slip_no: s.s_slip_no,
      customer: s.s_customer,
      item_name: s.s_item_name,
      s_type: s.s_type
    }
  }
}
export default getters
